/**
 *  GA统计
 */
export function IndexNewGAEvent() {
    $(() => {
      /**
       * @description GTM事件处理
       * @param {*} params 参数传递
       */
      const indexNewGAEvent = (params,event_name) => {
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: "ga4Event",
          event_name: event_name,
          event_parameters: {
            current_page: window.location.href, // current page url
            ...params
          }
        });
      }
        const isMobile = () => {
          return document.documentElement.clientWidth < 1024
        }
      
        // footer-new组件文字的埋点
        $('.footer-new .nav-item').click(function () {
          const position =  $(this).parent().siblings('p').first().text();
          const button_name =$(this).find('a').text() || $(this).text().trim()
          const link = $(this).find('a').attr("href")
          const params = {
            position: position,
            module: 'Text Entry',
            button_name: button_name
          }
          if(link){
            params.link =link
          }
          indexNewGAEvent(params,'footer_user_clicks4.0')
        })

        // footer-new组件媒体的埋点
        $('.footer-new .footer-media-item').click(function () {
          const position =  $(this).find('a').data("name")
          const link = $(this).find('a').attr("href")
          const params = {
            position: position,
            module: 'Social Share'
          }
          if(link){
            params.link =link
          }
          indexNewGAEvent(params,'footer_user_clicks4.0')
        })

        // 常规banner埋点
        $('.index-regular-banner .swiper-slide').click(function () {
          const position =  $(this).data("swiper-slide-index")+1
          let itemTitle = ""
          if(isMobile()){
            itemTitle = $(this).find('.mb-h2').text()?.trim() || "single_pic"
          }else{
            itemTitle = $(this).find('.pc-h2').text()?.trim() || "single_pic"
          }

          const buttonName =$(this).find('.index-button span').text()
          const link = $(this).find("a").attr("href")
          const type = $(this).find('.general-img-box').length > 0 ? "common_ban" : "selling_points_ban"
          const params = {
            position: position,
            module: itemTitle,
            type: type
          }
          if(link){
            params.link =link
          }
          if(buttonName){
            params.button_name =buttonName
          }
          indexNewGAEvent(params,'home_page_banner4.0')
        })

        // 最新动态的埋点
        $('.latest-news-box .news-item a').click(function () {
          const title = $('.latest-news-box').find('.news-title').text()
          const position =$(this).find('.news-content').text()
          const link = $(this).attr("href")
          const params = {
            position: position,
            module: title,
            type: 'Latest Updates',
          }
          if(link){
            params.link =link
          }
          indexNewGAEvent(params,'home_page_latest_updates4.0')
        })

        $('.latest-news-box .news-btn a').click(function () {
          const title = $('.latest-news-box').find('.news-title').text()
          const link = $(this).attr("href")
          const button_name = $(this).find('.index-button span').text().trim()
          const params = {
            module: title,
            type: 'Latest Updates',
            button_name: button_name
          }
          if(link){
            params.link =link
          }
          indexNewGAEvent(params,'home_page_latest_updates4.0')
        })

        $('.latest-news-box .news-btn-mb a').click(function () {
          const title = $('.latest-news-box').find('.news-title').text()
          const link = $(this).attr("href")
          const button_name = $(this).text().trim()
          const params = {
            module: title,
            type: 'Latest Updates',
            button_name: button_name
          }
          if(link){
            params.link =link
          }
          indexNewGAEvent(params,'home_page_latest_updates4.0')
        })
    })
  }